import { memo, useEffect, useState } from 'react';
import classNames from 'classnames';

import Button from '@/components/button/Button';
import SwitchItem from '@/components/dropdown/components/foldout/SwitchItem';
import { FoldoutItemProps } from '@/components/dropdown/types';
import RadioButton from '@/components/radioButton/RadioButton';

const FoldoutItem = ({
	handleItem,
	item,
	optionAdditionalSubValueKey,
	optionAvaKey,
	optionAvaPosition,
	optionCheckedKey,
	optionContinuationKey,
	optionDescriptionKey,
	optionFlagKey,
	optionFlagProperty,
	optionForDisabled,
	optionIconKey,
	optionLabelKey,
	optionAdditionalLabelKey,
	optionSubValueKey,
	optionTitleKey,
	optionTypeKey,
	optionValueKey,
	selectValue,
	optionButtonType,
	optionClassName,
	type,
}: FoldoutItemProps) => {
	const [checked, setChecked] = useState<boolean>(false);

	useEffect(() => {
		if (type === 'multi') {
			const valueKey = optionValueKey || 'key';
			setChecked(
				selectValue
					? !!selectValue.find((el: any) => el[valueKey] === item[valueKey])
					: false,
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectValue, item]);

	const titleKey = optionTitleKey || 'title';
	const typeKey = optionTypeKey || 'type';
	const valueKey = optionValueKey || 'key';
	const labelKey = optionLabelKey || 'label';

	return (
		<div
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				return (
					!item[labelKey] &&
					!item[optionForDisabled as any] &&
					handleItem(item, null, checked)
				);
			}}
			className={classNames('section-item', {
				disabled: item[labelKey] || item[optionForDisabled as any],
			})}
		>
			{type !== 'multi' ? (
				<>
					{item[typeKey] === 'checkbox' && (
						<SwitchItem
							checked={!!item[optionCheckedKey as any]}
							label={item[titleKey]}
						/>
					)}
					{(typeof item[typeKey] === 'undefined' || item[typeKey] === 'button') && (
						<Button
							active={!!(selectValue && item[valueKey] === selectValue[valueKey])}
							iconClassName={
								item[optionFlagKey as any] && (optionFlagProperty as string)
							}
							iconName={
								(item[optionIconKey as any] || item[optionFlagKey as any]) &&
								(item[optionIconKey as any] ||
									(item[optionFlagKey as any] &&
										`${optionFlagProperty}-${item[optionFlagKey as any]}`))
							}
							avaName={item[optionAvaKey as any]}
							avaOutside={item[optionAvaPosition as any]}
							description={item[optionDescriptionKey as any]}
							disabled={item[optionForDisabled as any]}
							title={`${item[titleKey]} ${optionContinuationKey || ''}`.trim()}
							subTitle={item[optionSubValueKey as any]}
							additionalSubTitle={item[optionAdditionalSubValueKey as any]}
							type={optionButtonType as any}
							label={item[labelKey] || item[optionAdditionalLabelKey as any]}
							labelColor="blue"
							tabIndex={0}
							dataName={item[titleKey]}
							className={classNames(optionClassName, item.className)}
						/>
					)}
				</>
			) : (
				<RadioButton text={item[titleKey]} checked={checked} />
			)}
		</div>
	);
};

export default memo(FoldoutItem);
